import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { DxHttpModule } from 'devextreme-angular/http';
import { NestedOptionHost } from 'devextreme-angular/core';

import { routes } from './app-routing.module';
import { LoginTokenInterceptor } from './LoginTokenInterceptor';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { AuthGuardService } from './shared/services/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoginTokenInterceptor,
      multi: true,
    },
    provideNgxMask(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
      }),
      DxHttpModule,
    ),
    ...provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
    AuthService,
    ScreenService,
    AppInfoService,
    NestedOptionHost,
    AuthGuardService,
  ],
};
